import { fromJS } from 'immutable';

import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

export function fetchCustomerSpecialInstruction(customerSpecialInstruction_id) {
  return dispatch =>
    apiClient
      .get(`/customerspecialinstructions/${customerSpecialInstruction_id}/`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => {
        dispatch(genericErrorAction(error, 'REQUEST_CUSTOMER_SPECIAL_INSTRUCTION'));
      });
}

export function fetchCustomerSpecialInstructionsForCustomer(customer) {
  return dispatch =>
    apiClient
      .get('/customerspecialinstructions/', { params: { customer } })
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => {
        dispatch(genericErrorAction(error, 'REQUEST_CUSTOMER_SPECIAL_INSTRUCTIONS_FOR_CUSTOMER'));
      });
}

export function fetchCustomerSpecialInstructionsForCustomerWithTypes(customer, types) {
  return dispatch => {
    const typesString = types.join(',');
    return apiClient
      .get('/customerspecialinstructions/', { params: { customer, applies_to__in: typesString } })
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, 'REQUEST_CUSTOMER_SPECIAL_INSTRUCTIONS_FOR_CUSTOMER')));
  };
}

export function patchCustomerSpecialInstruction(customerSpecialInstruction_id, values) {
  return dispatch =>
    apiClient
      .patch(`/customerspecialinstructions/${customerSpecialInstruction_id}/`, values)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Special instruction updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return fromJS(response.data);
      })
      .catch(error => {
        dispatch(genericErrorAction(error, 'EDIT_CUSTOMER_SPECIAL_INSTRUCTION'));
      });
}

export function createCustomerSpecialInstruction(values) {
  return dispatch =>
    apiClient
      .post(`/customerspecialinstructions/`, values)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Special instruction created',
            level: 'success',
            dismissible: true,
          }),
        );
        return fromJS(response.data);
      })
      .catch(error => {
        dispatch(genericErrorAction(error, 'CREATE_CUSTOMER_SPECIAL_INSTRUCTION'));
      });
}

export function deleteCustomerSpecialInstruction(customerSpecialInstruction_id) {
  return dispatch =>
    apiClient
      .delete(`/customerspecialinstructions/${customerSpecialInstruction_id}/`)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Special instruction deleted',
            level: 'success',
            dismissible: true,
          }),
        );
        return { success: true };
      })
      .catch(error => {
        dispatch(genericErrorAction(error, 'DELETE_CUSTOMER_SPECIAL_INSTRUCTION'));
      });
}
